import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import PageHeader from "../components/pageHeader";


const CartData =()=>{

    const [dataCartList, setDataCartList] = useState([]);

        // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/CartList/Get-GetCartListAll', setDataCartList);

    }, [dataCartList]);

    const columns = [
        {
            name: "Image",
            cell: (row) => <img className="m-2" src={`../images/products/full/${row.image}`} alt=" " width="80px" />,
            width: "110px"

        },
        {
            name: "Customer",
            selector: row => (
                <>
                    {row.userName}<br/>{row.email} <br /> {row.mobile}
                </>
            ),
            width: "200px"
        },
        {
            name: "Artwork Title",
            selector: (row) => row.productTitle,
            width: "200px",
            wrap: true,
        },
        {
            name: "Price",
            selector: (row) => row.price,
            width: "100px"
        },
        {
            name: "Artist",
            selector: (row) => row.artistName,
            width: "200px"
        },
        {
            name: "Date",
            // selector: (row) => row.createdOn,
            selector: (row) => new Date(row.createdOn).toLocaleDateString('en-GB',{day: 'numeric', month: 'short', year: 'numeric'}),

        },
        {
            name: "Status",
            selector: (row) => row.statusName,            
            width: "150px"
        },
        {
            name: "Action",
            cell: (row) => <><button className="btn btn-light" onClick={() => onDeleteClick(row.id)}><i className="bi bi-trash3-fill"></i></button></>
        },
    ];

    const onDeleteClick = async (id) => {
        const confirmed = window.confirm("Are you sure you want to Delete Cart Data ?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {
            const response = await fetch(`https://igapi.heuristticminds.com/api/CartList/Delete-DeleteCartListDetails?id=` + id, {
                method: 'DELETE'
            });
            if (response.ok) {
                // Refresh cart data if deletion was successful
                const url = `https://igapi.heuristticminds.com/api/CartList/Get-GetCartListAll`;
                fetchData(url, setDataCartList);
            } else {
                // Server responded with an HTTP status code outside the range 200-299
                console.error('Failed to delete cart item. Status:', response.status);
            }
        }
        catch (error) {

            console.error('Error saving form data:', error);
        }
        //bindgrid 
    };


    return(
        <div>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <div>
                        <PageHeader name='Cart Data' icon='bi bi-cart-fill' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">Cart Data</div>
                                        <div className="card-body">

                                        <div className="ps-2 pe-2">
                                                <DataTable
                                                    columns={columns}
                                                    data={dataCartList}
                                                    pagination
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    )
};
export default CartData